<template>
  <div class="layout column ma-0 main-page">
    <div class="main-promo text-xs-center">
      <div class="main-promo__wrap">
        <div class="main-promo__logo" :class="{ has_stream }">
          <img src="@/assets/img/logo.png" alt="Red Bull River Runes logo" />
        </div>
        <div style="padding:30px 0;">
          <ExpandTransition>
            <div v-if="has_stream" class="main-promo__stream">
              <div
                class="main-promo__stream_close"
                @click="isStreamOpen = !isStreamOpen"
              >
                <SvgIcon size="13" name="close" />
              </div>
              <div class="main-promo__stream_wrap">
                <iframe
                  src="https://player.twitch.tv/?channel=redbullrus&parent=riverrunes.gg&parent=localhost&parent=r1v1rrunes.redbull.com&parent=riverrunes.redbull.com"
                  frameborder="0"
                  allowfullscreen="true"
                  scrolling="no"
                  height="300"
                  width="100%"
                ></iframe>
              </div>
            </div>
          </ExpandTransition>
        </div>
        <div class="main-promo__text">
          <div class="main-promo__text_org">Red Bull River Runes</div>
          <div v-typed="typedOptions" class="main-promo__text_promo_title">
            <p>Rule The River</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="layout column">
        <a name="about"></a>
        <div class="page-section about about_tournament" id="about">
          <div class="page-section__content">
            <div class="title text-uppercase">О турнире</div>

            <div class="page-section_card">
              <div class="about__content_text">
                <p>
                  Возвращение турнира по Dota 2 в режиме 1v1 в третьем сезоне!
                  Новые жаркие бои на средней линии ждут вас!
                </p>
                <p>
                  Регистрируйтесь на квалификации прямо сейчас, побеждайте и
                  получайте слот на финал!
                </p>
                <p>
                  16 участников из 8 онлайн квалификаций и 8 Wildcard отборочных
                  поборются за главный приз финала – мощный игровой сетап!
                </p>
                <div class="video__wrap">
                  <iframe
                    src="https://vk.com/video_ext.php?oid=-174875268&id=456239338&hash=c8b51c1886e32254"
                    width="100%"
                    height="240"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              <a name="map"></a>
              <div class="about__map" id="map">
                <div class="about__map_text">
                  <p>Карта для проведения квалификаций:</p>
                  <p class="subtitle">Red Bull River Runes</p>
                </div>
                <div class="about__map_actions">
                  <app-btn
                    round
                    color="blue-grad"
                    href="https://steamcommunity.com/sharedfiles/filedetails/?id=1570316591&amp;searchtext=River+runes"
                    target="_blank"
                    @click="$app.metrics('download-map')"
                  >
                    <span>Скачать карту</span>
                  </app-btn>
                  <div class="spacer"></div>
                  <app-btn
                    round
                    color="red-grad"
                    to="/how-to-play"
                    @click="$app.metrics('how-to-play')"
                  >
                    <span>Как играть</span>
                  </app-btn>
                  <!-- <app-btn
                    round
                    color="red-grad"
                    href="https://www.redbull.com/ru-ru/red-bull-River-runes"
                    target="_blank"
                    >Как играть</app-btn
                  > -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="qualifications"
          class="page-section qualifications qualifications__list online"
        >
          <a name="qualifications"></a>
          <div class="page-section__content">
            <div class="title text-uppercase">
              {{
                needShowPastTournaments
                  ? "Прошедшие турниры"
                  : "Online квалификация"
              }}
            </div>
            <div
              v-if="pastTournaments.length"
              class="qual-filter layout row wrap align-center justify-center"
            >
              <app-btn
                :color="showPastTrournaments ? 'red-grad' : 'blue-grad'"
                class="qual-filter__btn"
                round
                @click="showPastTrournaments = false"
              >
                <span>Будущие квалификации</span>
              </app-btn>
              <app-btn
                :color="showPastTrournaments ? 'blue-grad' : 'red-grad'"
                class="qual-filter__btn"
                round
                @click="showPastTrournaments = true"
              >
                <span>Прошедшие квалификации</span>
              </app-btn>
            </div>
            <div class="layout row wrap justify-center">
              <div class="flex xs12"><div class="loader"></div></div>
              <div
                class="flex xs12 sm6 md4"
                v-for="item in tournamentsToShow"
                :key="item.id"
              >
                <HomeTournamentItem
                  :item="item"
                  :registred="participation.includes(item.id)"
                />
              </div>
            </div>
          </div>
        </div>

        <WildCardSection />

        <div
          class="page-section qualifications qualifications__list offline grand_final"
          v-if="grandFinal"
        >
          <div class="page-section__content">
            <div class="title text-uppercase">Гранд-финал</div>
            <div class="layout row wrap">
              <div class="flex xs12">
                <div class="qualifications__item container">
                  <div class="layout row wrap align-center justify-center">
                    <div class="field field_name">
                      <div class="label">Название</div>
                      <div class="info">
                        <span class="ellipsis">{{ grandFinal.name }}</span>
                      </div>
                    </div>
                    <div class="field field_date">
                      <div class="label">Дата и время</div>
                      <div class="info">
                        <span class="ellipsis">{{
                          grandFinal.starts_at | dayjs("DD.MM.YYYY HH:mm")
                        }}</span>
                      </div>
                    </div>
                    <div class="field field_count">
                      <div class="label">Участники</div>
                      <div class="info justify-center">
                        <span class="ellipsis">{{
                          grandFinal.players_limit
                        }}</span>
                      </div>
                    </div>
                    <div class="field field_address">
                      <div class="label">Адрес</div>
                      <div class="info">
                        {{ grandFinal.address }}
                      </div>
                    </div>
                    <div class="field field_btn">
                      <app-btn
                        :to="`/tournament/${grandFinal.id}`"
                        color="yellow-grad"
                        border="bottom"
                        @click="$app.metrics('click-tournament-details')"
                      >
                        Подробнее
                      </app-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="page-section partners partners__text">
          <div class="page-section__content">
            <div class="title text-uppercase">Партнеры</div>
            <div class="partners__list">
              <AppBtn
                v-for="(item, i) in partners"
                :key="i"
                :href="item.link"
                target="_blank"
                link
                class="ma-3 partners__item"
              >
                <div class="partners__item-wrap">
                  <img :src="item.logo" :alt="item.name" />
                  <p v-if="item.descr" v-html="item.descr" />
                </div>
              </AppBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minBy from "lodash/first";
import sortBy from "lodash/sortBy";
import { mapGetters } from "vuex";
import tournamentsService from "@/services/tournaments";
import typed from "@/core/directives/typed";
// import SimpleTooltip from "@/components/ui/tooltip/SimpleTooltip";
import { ExpandTransition } from "@/components/common/transitions";

import HomeTournamentItem from "@/components/tournament/home/HomeTournamentItem";
import { checkIsOver } from "@/components/tournament/types";
import WildCardSection from "@/components/wildcards/WildCardSection";

export default {
  components: {
    HomeTournamentItem,
    // SimpleTooltip,
    ExpandTransition,
    WildCardSection
  },
  directives: { typed },

  data: () => ({
    tournaments: [],
    pastTournaments: [],
    showPastTrournaments: false,
    interval: null,
    isStreamOpen: true,
    grandFinalStarted: false
  }),

  computed: {
    partners() {
      return this.$store.getters.partners;
    },

    has_stream() {
      return this.isStreamOpen;
      // return this.grandFinalStarted && this.isStreamOpen;
    },

    needShowPastTournaments() {
      return this.showPastTrournaments && this.pastTournaments.length;
    },

    tournamentsToShow() {
      return this.needShowPastTournaments
        ? this.pastTournaments
        : this.onlineList;
    },

    onlineList() {
      return sortBy(
        this.tournaments.filter(o => o.type === 1),
        ["starts_at"]
      );
    },

    offline() {
      return minBy(
        this.tournaments.filter(o => o.type === 0),
        "starts_at"
      );
    },

    grandFinal() {
      return minBy(
        this.tournaments.filter(o => o.type === 2),
        "starts_at"
      );
    },

    typedOptions() {
      return {
        cursorSpanText: "",
        firstTimeStart: 1000,
        // writeByWord: true,
        onLoopComplete: this.completedLoopHandler
      };
    },

    ...mapGetters("tournaments", ["participation"])
  },

  mounted() {
    this.checkGrandFinal();
    if (!this.grandFinalStarted) {
      this.interval = setInterval(() => {
        this.checkGrandFinal();
      }, 1000);
    }
  },

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },

  created() {
    this.fetchData();
  },

  methods: {
    checkGrandFinal() {
      this.grandFinalStarted =
        this.grandFinal &&
        this.$dayjs.unix(this.grandFinal.starts_at).isBefore(this.$dayjs());

      if (this.grandFinalStarted && this.interval) clearInterval(this.interval);
    },

    async fetchData() {
      const list = await tournamentsService.fetchTournaments();

      this.pastTournaments = sortBy(
        list.filter(o => checkIsOver(o.status)),
        ["starts_at"]
      );

      this.tournaments = sortBy(
        list.filter(o => !checkIsOver(o.status)),
        ["starts_at"]
      );
    },

    completedLoopHandler(vnode) {
      return new Promise(resolve => {
        vnode.elm.classList.remove("blink-animation");
        setTimeout(() => {
          vnode.elm.classList.add("blink-animation");
        });
        resolve();
      });
    }
  }
};
</script>

<style lang="scss">
.video__wrap {
  margin: 30px auto;
  width: 100%;
  max-width: 420px;

  box-shadow: 0px 4px 20px #fbc33e;
  border-radius: 6px;
  overflow: hidden;
  background: #000a25;

  iframe {
    display: block;
  }
}

.is-registred-on-tour {
  position: absolute;
  top: 16px;
  right: 25px;

  .check-wrap {
    border: 3px solid #5bb34f;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5bb34f;
    transition: 0.3s;

    &:hover {
      box-shadow: 0px 0px 10px #27c400, inset 0px 0px 10px #27c400;
    }
  }
}

.blink-animation {
  animation-duration: 0.4s;
  animation-timing-function: step-start;
  animation-delay: 0.25s;
  animation-iteration-count: 3;
  animation-play-state: running;
  animation-name: blink;
}

.main-page {
  .page-section {
    padding-bottom: 75px;
  }

  @include breakpoint("sm-and-down") {
    .page-section {
      padding-bottom: 40px;
    }
  }
}

.main-promo {
  position: relative;
  padding-bottom: 75px;
  background: url("~@/assets/img/head-bg.jpg") no-repeat top center;
  background-size: 100% auto;

  @media only screen and (max-width: 1456px) {
    background-size: auto 670px;
  }

  &__wrap {
    position: relative;
    z-index: 5;
    padding: 30px;
  }

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 65%;
    background: gradient(#000a25, #000, to top, 1, 0);
    z-index: 4;
  }

  &:after {
    transform: rotate(180deg);
    bottom: auto;
    top: 100%;
  }

  &__text {
    font-family: $second-font-family;
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    &_org {
      font-size: 22px;
      line-height: 27px;
      text-shadow: 0 3px 3px #000;
    }

    &_promo_title {
      @include brushUpFont;
      color: #fbc33e;
      text-shadow: 0 8px 16px rgba(#000, 0.8);
      font-size: 80px;
      line-height: 80px;
      min-height: 80px;
      margin: 10px 0;

      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  }

  &__logo {
    img {
      width: 325px;
      transition: $primary-transition;
      will-change: width;
    }

    &.has_stream {
      img {
        width: 131px;
      }
    }
  }

  &__stream {
    margin: 0 auto;
    max-width: 530px;
    width: 100%;
    height: 300px;
    transition: 0.3s;
    will-change: height;
    position: relative;

    &_wrap {
      width: 100%;
      height: 100%;
      box-shadow: 0px 4px 20px #fbc33e;
      border-radius: 6px;
      overflow: hidden;
      background: #000a25;
    }

    &_close {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: -20px;
      transition: $primary-transition;
      transition-property: opacity, transform;
      will-change: opacity, transform;

      :not(.has_stream) + .main-promo__stream & {
        transform: scale(0.5);
        opacity: 0;
      }

      &:hover {
        transform: rotate(180deg);
      }
    }
  }

  // .container,
  &__text,
  &__logo {
    position: relative;
    z-index: 6;
  }

  @include breakpoint("xs-only") {
    padding: 20px;
    padding-bottom: 50px;

    &__text {
      font-size: 14px;

      &_org {
        font-size: 16px;
      }
    }

    &__logo {
      img {
        width: 50%;
      }
    }
  }
}
.page-section__content {
  .about {
    &__content_text {
      margin: 0 auto;
      max-width: 960px;
    }

    &__map {
      text-align: center;
      margin: 0 auto;
      max-width: 420px;

      &_text {
        font-family: $second-font-family;
        margin-bottom: 20px;

        p {
          font-weight: 300;
          font-size: 20px;
          line-height: 24px;
          margin-bottom: 0;

          &.subtitle {
            font-weight: 900;
            font-size: 36px;
            line-height: 44px;
          }
        }
      }

      &_actions {
        display: flex;
        align-items: center;

        .btn {
          padding: 10px 30px;
          margin: 0 10px;
        }
      }
    }

    @include breakpoint("xs-only") {
      &__map_text {
        p {
          font-size: 16px;
        }
        p.subtitle {
          font-size: 26px;
        }
      }
      .title {
        font-size: 30px;
      }
      &__map_actions {
        flex-wrap: wrap;
        flex: 1 0 100%;
        .btn {
          margin: 0;
          margin-top: 15px;
          width: 100%;
        }
      }
    }
  }
}

.qualifications {
  &__text {
    .page-section__content {
      margin: 0 auto;
      max-width: 960px;
    }
  }

  &.offline {
    .qualifications__item {
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .field_address .info {
      line-height: 100%;
    }
  }

  &__item {
    position: relative;
    background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);
    border-radius: 6px;

    .flex {
      .online & {
        padding: 12px 15px !important;

        &:first-child,
        &:last-child {
          padding-top: 15px !important;
        }
      }
    }

    .label {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 12px;
    }

    .info {
      background: rgba(#000a25, 0.5);
      border-radius: 6px;
      padding: 8px;
      overflow: hidden;
      font-weight: 800;
      font-size: 14px;
      line-height: 108.95%;
      letter-spacing: 0.02em;

      .offline & {
        padding: 0px 8px;
        min-height: 40px;
        display: flex;
        align-items: center;

        font-size: 14px;
        line-height: 20px;

        span {
          display: inline-block;
          max-width: 100%;
        }
      }
    }

    .btn {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 28px;
    }

    @include breakpoint("md-only") {
      .offline & {
        .field_name,
        .field_address {
          flex: 1 1 70%;
        }

        .field_date {
          flex: 1 1 20%;
        }
        .field_count {
          flex: 1 1 10%;
        }

        .field_btn {
          flex: 1 1 30%;
          .btn {
            display: flex;
          }
        }
      }
    }
  }

  @include breakpoint("sm-and-down") {
    &__item {
      padding: 15px 10px;

      .btn {
        width: 100%;
      }

      .offline & {
        > .layout {
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;

          .field {
            align-self: stretch;
            flex-basis: 100%;
            max-width: 100%;
          }
          .field_date,
          .field_count {
            flex-basis: 50%;
            max-width: 50%;
            align-self: center;
          }
        }
      }
    }
  }
}

.partners {
  &.page-section {
    padding-bottom: 40px;
    @include breakpoint("sm-and-down") {
      padding-bottom: 0;
    }
  }
  &__text {
    margin: 0 auto;
    max-width: 960px;
  }

  &__item {
    vertical-align: top;
    text-transform: none;
    font-weight: normal;

    p {
      font-size: 14px;
      line-height: 1.2;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  &__item-wrap {
    img {
      max-width: 200px;
      max-height: 100px;
      @include breakpoint("sm-and-down") {
        height: auto;
      }
    }
  }
}

.qual-filter {
  padding: 10px;

  &__btn {
    margin: 10px;
  }

  @include breakpoint("xs-only") {
    &__btn {
      /* margin: 0; */
      /* margin-top: 15px; */
      width: 100%;
    }
  }
}

@include breakpoint("sm-and-down") {
  .qualifications__text,
  .partners__text {
    .page-section__content {
      p:not(.title) {
        padding: 0 20px;
        text-align: center;
      }
    }
  }
}

@include firefox() {
  .page-section__content {
    .main-promo__text {
      font-family: $second-font-family !important;
      font-weight: 300 !important;
    }

    .about__map_text {
      font-family: $second-font-family !important;
      font-weight: 200 !important;

      p {
        font-family: $second-font-family !important;
        font-weight: 200 !important;

        &.subtitle {
          font-family: $second-font-family !important;
          font-weight: 900 !important;
        }
      }
    }
  }
}
</style>
